import { Builder } from '@builder.io/react';
import appState from '@builder.io/app-context';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var registerDataPlugin = function (config, apiOperationsFromSettings) { return __awaiter(void 0, void 0, void 0, function () {
    var registerEditors, onSave, savedSettings;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                registerEditors = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var savedSettings, allSettings, _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                savedSettings = appState.user.organization.value.settings.plugins.get(config.id);
                                _a = [__assign({}, config)];
                                return [4 /*yield*/, apiOperationsFromSettings(savedSettings)];
                            case 1:
                                allSettings = __assign.apply(void 0, _a.concat([_b.sent()]));
                                appState.registerDataPlugin(allSettings);
                                return [2 /*return*/];
                        }
                    });
                }); };
                onSave = config.onSave;
                config.onSave = function (actions) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, actions.updateSettings({ hasConnected: true })];
                            case 1:
                                _a.sent();
                                if (!onSave) return [3 /*break*/, 3];
                                return [4 /*yield*/, onSave(actions)];
                            case 2:
                                _a.sent();
                                _a.label = 3;
                            case 3:
                                registerEditors();
                                return [2 /*return*/];
                        }
                    });
                }); };
                Builder.register('plugin', __assign(__assign({}, config), { isDataPlugin: true }));
                Builder.register('app.onLoad', function (_a) {
                    var triggerSettingsDialog = _a.triggerSettingsDialog;
                    return __awaiter(void 0, void 0, void 0, function () {
                        var pluginSettings, hasConnected;
                        var _b;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    pluginSettings = appState.user.organization.value.settings.plugins.get(config.id);
                                    hasConnected = (_b = pluginSettings) === null || _b === void 0 ? void 0 : _b.get('hasConnected');
                                    if (!!hasConnected) return [3 /*break*/, 2];
                                    return [4 /*yield*/, triggerSettingsDialog(config.id)];
                                case 1:
                                    _c.sent();
                                    _c.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    });
                });
                savedSettings = appState.user.organization.value.settings.plugins.get(config.id);
                if (!savedSettings) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, registerEditors()];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };

export { registerDataPlugin };
//# sourceMappingURL=index.es5.js.map
